import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import ModalCreateUser from './ModalCreateUser';
import ModalModifyUser from './ModalModifyUser';
import { Card, Typography } from "@material-tailwind/react";

function ListUsers() {
    const [datas, setDate] = useState([]);
    const [roles, setRoles] = useState([]);
    const [ecrans, setEcrans] = useState([])
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0);
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    const [usedPdv, setUsedPdv] = useState(new Set());   // id_pdv réellement déployés (programmes + devices)
    const [onlyUnused, setOnlyUnused] = useState(false);
    // const [open, setOpen] = useState('block');
    const [choosenId, setChoosenId] = useState({
        id: '',
        username: '',
        email: '',
        id_pdv: '',
        authorized: '',
        hashed_password: '',
        pages: '',
        role: '',
        ecran: ''
    });

    let token = localStorage.getItem("token");

    useEffect(() => {

        const headers = {
            'x-access-token': token,
            'Content-Type': 'application/json'
        };
        const data = { token: token };
        console.log(data);


        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/listeUsers`, data, { headers })
            .then(res => {
                console.log(res);

                setDate(res.data);
            }).catch(err => console.log(err));

        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/roles`, data, { headers })
            .then(result => {
                console.log(result.data);
                setRoles(result.data);
            }).catch(err => console.log(err));

        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/ecranPriceEat`, data, { headers })
        .then(results => {
            console.log(results.data);
            setEcrans(results.data);
        }).catch(err => console.log(err));
        }, []);

    // Détermine quels id_pdv sont réellement UTILISÉS : présents dans un programme (déployé sur
    // un device) ou référencés par un device. Un user dont l'id_pdv n'apparaît nulle part = à nettoyer.
    useEffect(() => {
        const IP = `${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}`;
        Promise.all([
            axios.get(`${IP}/gat_all_programme`).then(r => r.data).catch(() => []),
            axios.get(`${IP}/InterfaceTizenDevice`).then(r => r.data).catch(() => []),
        ]).then(([programmes, devices]) => {
            const set = new Set();
            (programmes || []).forEach(p => { if (p.idPdv) set.add(String(p.idPdv).trim()); });
            (devices || []).forEach(d => {
                if (d._id_pdv) set.add(String(d._id_pdv).trim());
                if (d._room_id) set.add(String(d._room_id).trim());
            });
            setUsedPdv(set);
        });
    }, []);

    const isUsed = (u) => usedPdv.has(String(u?.id_pdv || '').trim());
    const unusedCount = datas.filter(u => !isUsed(u)).length;

    const setRoleForUser = (userId) => {
        // Find the role matching the user ID
        const userRole = roles.find(role => role.idUsers === userId);
        if (userRole) {
            // Update the state with the selected role

            setChoosenId(prevState => ({
                ...prevState,
                role: userRole.idRoles, // Assuming `idRoles` is the role ID
            }));
        }
    };

    const setEcranUser = (userName) => {


        const userEcran = ecrans.find(ecran => ecran.client_id === userName);
        if (userEcran) {
            // Update the state with the selected role
            setChoosenId(prevState => ({
                ...prevState,
                ecran: userEcran.ecran_titre, // Assuming `idRoles` is the role ID
            }));
        }
    }

    const handleRowClick = (data) => {
        setChoosenId({
            ...choosenId,
            id: data.Id,
            username: data.username,
            email: data.email,
            id_pdv: data.id_pdv,
            authorized: data.authorized,
            hashed_password: data.hashed_password,
            pages: data.pages,
        });
        setRoleForUser(data.Id);
        setEcranUser(data.username);
        setShowModalModify(true);
        // Set role for the selected user
    };

    const TABLE_HEAD = [
        { key: "username", text: "Nom Client / Client ID" },
        { key: "email", text: "Email" },
        { key: "id_pdv", text: "Id Pdv" },
        { key: "last_connected", text: "Dernière connexion" },
        { key: "authorized", text: "Autorisé" },
        { key: "used", text: "Statut" },
    ];

    // Valeur de tri normalisée : gère les colonnes CALCULÉES (`used` n'existe pas dans data)
    // et les null (authorized/last_connected) — l'ancien tri retournait 1 dans ces cas
    // => "Autorisé" et "Statut" n'étaient PAS triables.
    const sortValue = (item, key) => {
        if (key === 'used') return isUsed(item) ? 1 : 0;
        if (key === 'authorized') return item.authorized === 'yes' ? 1 : 0;
        if (key === 'last_connected') {
            const t = new Date(item.last_connected).getTime();
            return Number.isNaN(t) ? 0 : t;
        }
        return item[key];
    };

    const sorted = [...datas].sort((a, b) => {
        const aVal = sortValue(a, sortedBy);
        const bVal = sortValue(b, sortedBy);
        let cmp;
        if (typeof aVal === "number" && typeof bVal === "number") cmp = aVal - bVal;
        else cmp = String(aVal ?? '').localeCompare(String(bVal ?? ''), 'fr', { numeric: true });
        return counter % 2 === 0 ? cmp : -cmp;
    });

    const scrollToTop = () =>{
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
    };

    const ListTable = () => {
        return (
            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <span className="flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                const t = search.toLowerCase();
                                const matchSearch = t === '' ||
                                    String(item.username || '').toLowerCase().includes(t) ||
                                    String(item.email || '').toLowerCase().includes(t) ||
                                    String(item.id_pdv || '').toLowerCase().includes(t);
                                const matchUnused = !onlyUnused || !isUsed(item);
                                return matchSearch && matchUnused;
                            }).map((data, index) => {
                                return (
                                    <tr
                                        key={data.id}
                                        onClick={() => handleRowClick(data)}
                                        className="cursor-pointer border-b border-slate-100 transition-colors hover:bg-indigo-50/40"
                                    >
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.username}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.email}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.id_pdv}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {(() => {
                                                const t = new Date(data.last_connected).getTime();
                                                if (!data.last_connected || Number.isNaN(t)) {
                                                    return <span className="inline-flex rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">Jamais</span>;
                                                }
                                                const days = Math.floor((Date.now() - t) / (24 * 3600 * 1000));
                                                const cls = days <= 7 ? 'bg-emerald-100 text-emerald-700'
                                                    : days <= 90 ? 'bg-amber-100 text-amber-700'
                                                    : 'bg-rose-100 text-rose-700';
                                                const rel = days <= 0 ? "aujourd'hui" : days < 30 ? `il y a ${days} j`
                                                    : days < 365 ? `il y a ${Math.floor(days / 30)} mois` : `il y a ${Math.floor(days / 365)} an${days >= 730 ? 's' : ''}`;
                                                return (
                                                    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`} title={new Date(t).toLocaleString('fr-FR')}>
                                                        {rel}
                                                    </span>
                                                );
                                            })()}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm">
                                            <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${data.authorized === 'yes' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                                                {data.authorized === null ? 'no' : data.authorized}
                                            </span>
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm">
                                            {isUsed(data) ? (
                                                <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700">
                                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />Utilisé
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center gap-1 rounded-full bg-rose-100 px-2 py-0.5 text-xs font-medium text-rose-700" title="id_pdv absent des programmes et devices — à nettoyer">
                                                    <span className="h-1.5 w-1.5 rounded-full bg-rose-500" />Non utilisé
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <h1 className="text-xl font-semibold text-slate-800">Utilisateurs</h1>
                        <p className="text-sm text-slate-500">
                            {datas.length} utilisateur(s)
                            {unusedCount > 0 && <span className="text-rose-600"> · {unusedCount} non utilisé{unusedCount > 1 ? 's' : ''} à nettoyer</span>}
                        </p>
                    </div>
                    <div className="flex w-full items-center gap-2 sm:w-auto">
                        <button
                            type="button"
                            onClick={() => setOnlyUnused(v => !v)}
                            className={`flex h-10 shrink-0 items-center gap-2 rounded-xl border px-3 text-sm font-medium transition ${onlyUnused ? 'border-rose-300 bg-rose-50 text-rose-700' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'}`}
                            title="N'afficher que les utilisateurs non utilisés"
                        >
                            <span className={`h-2 w-2 rounded-full ${onlyUnused ? 'bg-rose-500' : 'bg-slate-300'}`} />
                            Non utilisés{unusedCount > 0 ? ` (${unusedCount})` : ''}
                        </button>
                        <div className="relative flex h-10 w-full items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20 sm:w-72">
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                                type="text"
                                id="search"
                                placeholder="Rechercher un utilisateur.."
                                onChange={(e) => setSearch(e.target.value)} />
                        </div>
                    </div>
                </div>
                <main>
                    {/* <DefaultSidebar isOpen={open} /> */}
                    {ListTable()}
                    <button
                        type="button"
                        className="fixed bottom-16 right-6 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md hover:bg-slate-50"
                        onClick={() => scrollToTop()}
                        title="Remonter"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        className="fixed bottom-6 right-6 flex h-11 w-11 items-center justify-center rounded-full bg-indigo-500 text-white shadow-lg hover:bg-indigo-600"
                        onClick={() => setShowModal(true)}
                        title="Ajouter un utilisateur"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                        </svg>
                    </button>
                </main>
            </div>
            <ModalModifyUser isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenId={choosenId} />
            <ModalCreateUser isVisible={showModal} onClose={() => setShowModal(false)} />
        </Fragment>
    );
}
export default ListUsers;
